import { render, staticRenderFns } from "./ProductAssetsForm.vue?vue&type=template&id=4016f24f&lang=pug"
import script from "./ProductAssetsForm.vue?vue&type=script&lang=js"
export * from "./ProductAssetsForm.vue?vue&type=script&lang=js"
import style0 from "./ProductAssetsForm.vue?vue&type=style&index=0&id=4016f24f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports